import Fetchers from 'core/fetchers';
import ApplicationController from '../application_controller'

export default class CartActionController extends ApplicationController {
  static outlets = ['navigation--cart', 'containers--drawer-component']

  static values = {
    buttonSuccessIconPath: String,
    productId: String,
    designId: String,
    cvrResource: String,
  }

  addToCartOptions() {
    return {
      product_id: this.productIdValue,
      design_id: this.designIdValue,
      quantity: 1,
      store_id: null,
      campaign_id: null,
      info: {
        cvr_resource: this.cvrResourceValue,
      },
    };
  }

  addToCart(event) {
    const currentTarget = event.currentTarget;
    const postOptions = this.addToCartOptions();

    Fetchers.fetchJSON('/add_to_cart', 'POST', JSON.stringify(postOptions))
      .then(res => res.json())
      .then((data) => {
        if (!data.success) {
          throw new Error('Network response was not ok');
        }

        if (window.location.pathname == '/cart') {
          window.location.reload();
        } else {
          this.updateAddToCartButtonState(currentTarget);
          this.displaySuccessMessage(data);
          this.updateBadgeNotification(postOptions.quantity);

          if (this.hasNavigationCartOutlet) {
            this.navigationCartOutlet.fireRequestValue = true;
            this.openCartTray();
          }
        }
      }).catch(error => console.log(error));
  }

  updateAddToCartButtonState(button) {
    const imgTag = button.querySelector('img');
    const buttonContent = button.querySelector('.button__content');
    const defaultIconPath = imgTag.src;
    const defaultText = buttonContent.textContent;

    button.setAttribute('disabled', 'disabled');
    imgTag.src = this.buttonSuccessIconPathValue;
    buttonContent.textContent = 'Added!';

    setTimeout(() => {
      button.removeAttribute('disabled');
      imgTag.src = defaultIconPath;
      buttonContent.textContent = defaultText;
    }, 2500);
  }

  displaySuccessMessage(data) {
    if (!data.message) return;

    const pastMessage = document.querySelector('.jsAddToCartMessage');
    const node = new DOMParser().parseFromString(data.message, "text/html").body.firstElementChild;

    if (pastMessage) pastMessage.remove();

    document.querySelector('body').appendChild(node);

    setTimeout(() => {
      node.remove();
    }, 4500);
  }

  openCartTray() {
    this.containersDrawerComponentOutlet.open();
    this.navigationCartOutlet.lazyloadCartTray();
  }

  updateBadgeNotification(itemCount) {
    const badges = document.querySelectorAll('.jsNotificationBadge');

    badges.forEach((badge) => {
      const badgeNotification = badge.notification;
      const badgeValue = parseInt(badgeNotification.countValue) || 0;
      badgeNotification.countValue = badgeValue + itemCount;
      badgeNotification.updateCount();
    })
  }
}
